import React from 'react';
import { View, Text, StyleSheet, ViewStyle, TextStyle } from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';

interface StatItemProps {
  value: number;
  label: string;
  valueStyle?: TextStyle;
  labelStyle?: TextStyle;
  containerStyle?: ViewStyle;
}

export const StatItem: React.FC<StatItemProps> = ({
  value,
  label,
  valueStyle,
  labelStyle,
  containerStyle,
}) => (
  <View style={[styles.container, containerStyle]}>
    <Text style={[styles.value, valueStyle]}>{value}</Text>
    <Text style={[styles.label, labelStyle]}>{label}</Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  value: {
    fontSize: 14,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
    textAlign: 'center',
  },
  label: {
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textSecondary,
    lineHeight: 21,
    textAlign: 'center',
  },
});

